import React from 'react';
import PropTypes from 'prop-types';

// Components
import ListCard from '../../../components/ListCard';
import MultiHubStatusWidget from '../../../components/MultiHubStatusWidget';

// Constants
import { T, FONT_MONO } from '../../../constants/tokens';

export default function RoomListCard({ room, onClick, selectedCardObject }) {
  const status = room.getAlertStatus();
  const statusColor = status?.getColor()?.main;

  return (
    <ListCard
      statusColor={statusColor}
      onClick={onClick}
      isSelected={selectedCardObject != null && selectedCardObject.getID?.() === room.getID()}
      selectedColor={statusColor}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              lineHeight: '20px',
              letterSpacing: '-0.28px',
              color: T.ink,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {room.getIdentifier()}
          </div>
          <div
            style={{
              fontFamily: FONT_MONO,
              fontSize: 12,
              fontWeight: 500,
              lineHeight: '16px',
              textTransform: 'uppercase',
              color: T.muted
            }}
          >
            {status?.getDashboardStatus() ?? 'Unknown'}
          </div>
        </div>

        {room.getHubs()?.length >= 1 &&
          <div style={{ flex: 'none' }}>
            <MultiHubStatusWidget hubs={room.getHubs()} />
          </div>}
      </div>
    </ListCard>
  );
}

RoomListCard.propTypes = {
  room: PropTypes.object,
  onClick: PropTypes.func,
  selectedCardObject: PropTypes.object
};
